import { render, staticRenderFns } from "./perspectiveCard.vue?vue&type=template&id=96167b8c&scoped=true&"
import script from "./perspectiveCard.vue?vue&type=script&lang=js&"
export * from "./perspectiveCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96167b8c",
  null
  
)

export default component.exports